import request from "../plugins/axios";

// 预约列表
export function appointmentList(params) {
    return request({
        url: '/bankServiceAppointment/record',
        method: 'get',
        params: params
    })
}
// 预约详情
export function appointmentDetail(params) {
    return request({
        url: '/bankServiceAppointment/detail',
        method: 'get',
        params: params
    })
}
// 修改预约状态
export function editStatus(params) {
    return request({
        url: '/bankServiceAppointment/updateStatus',
        method: 'post',
        data: params
    })
}